import type { BadgeGroupBlock, Badge } from '../../../types/investigator';
import { PROVENANCE_PILL_CLASSES } from '../../../config/colors';

// info/warning/critical/success are status roles; `inferred` is a
// provenance tier, so its colour comes from the shared colors module
// (ticket 15) — violet, never a purple/green drift.
const VARIANT_STYLES: Record<Badge['variant'], string> = {
  info:     'bg-ring/20 text-ring border-ring/30',
  warning:  'bg-warning/20 text-warning border-warning/30',
  critical: 'bg-destructive/20 text-destructive border-destructive/30',
  success:  'bg-success/20 text-success border-success/30',
  inferred: PROVENANCE_PILL_CLASSES.inferred,
};

interface BadgeGroupProps {
  block: BadgeGroupBlock;
}

export default function BadgeGroup({ block }: BadgeGroupProps) {
  if (block.badges.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {block.badges.map((badge, i) => (
        <span
          key={i}
          className={`inline-flex items-center px-2.5 py-1 rounded-full border text-xs font-medium ${VARIANT_STYLES[badge.variant]}`}
        >
          {badge.label}
        </span>
      ))}
    </div>
  );
}
